import React from 'react';
// import logo from './logo.svg';
import './App.css';
import {BrowserRouter} from "react-router-dom";
import MainArea from "./components/MainArea/MainArea";
import FooterComponent from "./components/FooterComponent/FooterComponent";
import HeaderComponent from "./components/HeaderComponent/HeaderComponent";

function App() {
  return (
      <>
        <BrowserRouter>
          <header>
            <HeaderComponent />
          </header>
          <MainArea />
          <FooterComponent />
        </BrowserRouter>
      </>
  );
}

export default App;
